<article class="esn-island-card">
  <div class="esn-island-card__thumb">
    <esn-island-thumb class="esn-island-card__image" [imageUrl]="imageUrl()" />
    <div class="esn-island-card__actions">
      <ng-content select="[esnIslandCardActions]">
        <esn-icon-button icon="dots" [label]="actionsLabel()" (clicked)="actions.emit($event)" />
      </ng-content>
    </div>
  </div>

  <div class="esn-island-card__info">
    <div class="esn-island-card__titles">
      <!-- The name is the card's one real control; its ::after stretches over the whole card. -->
      <button type="button" class="esn-island-card__open" [attr.title]="name()" (click)="opened.emit()">
        {{ name() }}
      </button>
      <span class="esn-island-card__caption">{{ slug() }}</span>
    </div>
    <div class="esn-island-card__meta">
      <esn-status-badge [status]="status()">{{ statusLabel() }}</esn-status-badge>
      @if (version(); as v) {
        <span class="esn-island-card__caption">{{ v }}</span>
      }
    </div>
  </div>
</article>
